import { convexQuery } from '@convex-dev/react-query';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import { api } from '~/convex/_generated/api';
import type { Doc, Id } from '~/convex/_generated/dataModel';

export const ReportLayout = () => {
  const { id } = useParams<{ id: Id<'reports'> }>();
  const { t } = useTranslation();

  // Early validation: ensure id param exists
  if (!id) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-white">
        <div className="text-sm text-red-600">
          {t('report:errors.notFound')}
        </div>
      </div>
    );
  }

  return <ReportLayoutInner id={id} />;
};

const ReportLayoutInner = ({ id }: { id: Id<'reports'> }) => {
  const { t } = useTranslation();
  const {
    data: report,
    isLoading,
    isError,
  } = useQuery(convexQuery(api.reports.get, { id }));

  if (isError) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-white">
        <div className="text-sm text-red-600">
          {t('report:errors.notFound')}
        </div>
      </div>
    );
  }

  if (isLoading || !report) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-5">
        <Loader2 className="size-8 animate-spin" />
      </div>
    );
  }

  return <Outlet context={{ report }} />;
};

export type ReportContextType = { report: Doc<'reports'> };
